var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var d3 = require('d3');

function IndexConceptsSector(el) {
	var $el = $(el),
        metaData = JSON.parse($el.attr('data-metadata')),
        sectorData = JSON.parse($el.attr('data-chart')),
        chartDiv = '#sector-chart-'+metaData['concept_slug'],
        conceptName = metaData['concept_name'],
        benchmarkName = metaData['benchmark_name'];

    sectorData.forEach(function(d) {
    	d['activeweight'] = parseFloat(d['activeweight']);
    })

    var tooltip = d3.select("body").append("div").attr("class", "align-center sector-tool-tip").style("display", "none");

    var margin = {top: 20, right: 50, bottom: 150, left: 60}
        width = 1100 - margin.right - margin.left,
        height = 550 - margin.bottom - margin.top;

    var x = d3.scaleBand().rangeRound([0, width]).padding(0.3),
        y = d3.scaleLinear().range([height, 0]);

    var exposureExtent = d3.extent(sectorData, function(d) {return d['activeweight']});

    x.domain(sectorData.map(function(d) {return d['icb_names']}));
    y.domain([(exposureExtent[0] - 0.01),(exposureExtent[1] + 0.01) ]);

    var xAxis = d3.axisBottom(x),
        yAxis = d3.axisLeft(y).ticks(8).tickSizeInner(-width).tickFormat(function(d) {return (+d*100).toFixed() + "%"} );

    var svg = d3.select(chartDiv).append("div")
        .classed("svg-container", true)
    .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", "0 0 " + (width + margin.right + margin.left) + " " + (height + margin.bottom + margin.top))
        .classed("svg-content-responsive", true)
    .append('g')
    	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg.append("g")
    	.attr("class", "y axis")
        .call(yAxis);

    svg.append("g")
        .append("text")
        .attr("text-anchor", "middle")
        .attr("transform", "translate(" + (-margin.left + 20) + "," + height / 2 + ")rotate(-90)")
        .style("font-size", "16px")
        .style("font-family", "FFDINStdCondensedMedium")
        .text("Exposure");

    svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")  
        .style("text-anchor", "end")
        .attr("dx", "-.8em")
        .attr("dy", ".15em")
        .attr("transform", "rotate(-65)");;

    svg.append("g")
        .attr("class", "zero-line")
        .append("line")
        .attr("y1", y(0))
        .attr("y2", y(0))
        .attr("x2", width)
        .style("stroke", "#4a4a4a");

    svg.selectAll(".bar")
        .data(sectorData)
    .enter().append("rect")
        .attr("class", "sector-bar")
        .attr("y", function(d) {
            if (d['activeweight'] > 0){
                return y(d['activeweight']);
            } else {
                return y(0);
            }
        })
        .attr("x", function(d) {
            return x(d['icb_names']);
        })
        .attr("width", x.bandwidth())
        .attr("height", function(d) {
            return Math.abs(y(d['activeweight']) - y(0));
        })
        .style("fill", "#1a59c4")
        .on ("mouseover", function(d) {
            tooltip.style("display", "inline")
        })
        .on("mousemove", function(d){
            tooltip.style("display", "inline")
            tooltip.style("left", (d3.event.pageX + 20) + "px")
                .style("top", (d3.event.pageY - 20) + "px")
                .html(d['icb_names']+': <br>'+(+d['activeweight'] * 100).toFixed(2) +'%');
        })
        .on("mouseout", function(d){ tooltip.style("display", "none");});


}

module.exports = IndexConceptsSector;